/**
 * AI difficulty presets. The 2013 game had a single hand-tuned behaviour
 * (`df78ecf IA plus agressive de près`); here the same evaluator is knobbed.
 */

export type AiLevelName = "easy" | "normal" | "hard";

export interface AiLevel {
  /** Weight on closing distance to the chased opponent (0 = pure survival). */
  chaseWeight: number;
  /** Small score bonus for going straight — reduces pointless zig-zag. */
  straightBias: number;
  /** Per-tick chance of picking a random (still safe) move instead of the best one. */
  randomTurnChance: number;
  /** Run the brain only every Nth tick (reaction lag). 1 = every tick. */
  reactEvery: number;
  /** Extra look-ahead cells added to the raw safety margin. */
  extraMargin: number;
}

export const AI_LEVELS: Record<AiLevelName, AiLevel> = {
  easy: {
    chaseWeight: 0,
    straightBias: 40,
    randomTurnChance: 0.06,
    reactEvery: 3,
    extraMargin: 0,
  },
  normal: {
    chaseWeight: 8,
    straightBias: 25,
    randomTurnChance: 0.015,
    reactEvery: 2,
    extraMargin: 1,
  },
  hard: {
    chaseWeight: 22,
    straightBias: 12,
    randomTurnChance: 0,
    reactEvery: 1,
    extraMargin: 2,
  },
};
